import { useMutation } from "@tanstack/react-query";
import type { ColumnFiltersState } from "@tanstack/react-table";
import { apiClient } from "../../../../zodios/client";
import { clientToServerFiltering } from "../../../../components/table/utils";
import { useDates } from "../../../../dates/DatesContext";

export const useV4OrgReportExport = (filters: ColumnFiltersState, marketPlace: string) => {
  const { start, end } = useDates();
  return useMutation({
    mutationFn: async () =>
      await apiClient.getV4OrgReportExport({
        queries: {
          start_date: start.format("YYYY-MM-DD"),
          end_date: end.format("YYYY-MM-DD"),
          marketplace: marketPlace,
          report_type: "org_report",
          filters: clientToServerFiltering(filters),
        },
        responseType: "blob",
      }),
  });
};
